export const COLORS_LIST_LIMIT = 1000;

// หลักการทำงาน: รวม path สำหรับดึง master tinter list ให้ทุกหน้าขอรายการได้เกิน default 100 ของ backend
export const buildColorsListPath = () => {
  return `/colors?limit=${COLORS_LIST_LIMIT}`;
};
